import React from 'react';
import { Paper, Box } from '@mui/material';
import styles from './StatCard.module.css';

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  color?: 'primary' | 'success' | 'danger' | 'warning' | 'info';
  icon?: React.ReactNode;
}

export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  subtitle,
  color = 'primary',
  icon
}) => {
  const formatValue = (val: string | number) => {
    if (typeof val === 'number') {
      return val.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      });
    }
    return val || '0';
  };

  return (
    <Paper 
      elevation={3} 
      className={`${styles.statCard} ${styles[color]}`}
    >
      <Box className={styles.cardContent}>
        {icon && (
          <div 
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              flexShrink: 0,
              border: '2px solid rgba(255, 255, 255, 1)',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              color: '#2c3e50',
              fontSize: '28px'
            }}
          >
            {icon}
          </div>
        )}
        <Box className={styles.textContent}>
          <h3 
            style={{ 
              color: '#ffffff !important',
              fontWeight: 'bold !important',
              fontSize: '1.1rem !important',
              textShadow: '0 3px 8px rgba(0, 0, 0, 1) !important',
              letterSpacing: '0.8px !important',
              marginBottom: '8px !important',
              margin: '0 0 8px 0 !important',
              fontFamily: 'Roboto, Arial, sans-serif !important',
              WebkitTextFillColor: '#ffffff !important',
              background: 'none !important',
              textTransform: 'uppercase',
            }}
          >
            <strong>{title}</strong>
          </h3>
          <div 
            style={{ 
              color: '#ffffff !important',
              fontWeight: 'bold !important',
              fontSize: '2.2rem !important',
              textShadow: '0 4px 12px rgba(0, 0, 0, 1) !important',
              fontFamily: 'Roboto, Arial, sans-serif !important',
              marginBottom: '4px !important',
              lineHeight: '1.1 !important',
              WebkitTextFillColor: '#ffffff !important',
              background: 'none !important',
              letterSpacing: '0.5px !important'
            }}
          >
            <strong>{formatValue(value)}</strong>
          </div>
          {subtitle && (
            <span 
              style={{ 
                color: '#ffffff !important',
                fontWeight: 'bold !important',
                fontSize: '0.95rem !important',
                textShadow: '0 3px 8px rgba(0, 0, 0, 1) !important',
                fontFamily: 'Roboto, Arial, sans-serif !important',
                WebkitTextFillColor: '#ffffff !important',
                background: 'none !important',
                letterSpacing: '0.3px !important'
              }}
            >
              <strong>{subtitle}</strong>
            </span>
          )}
        </Box>
      </Box>
    </Paper>
  );
};